import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class PositiontypeController {
  constructor(
    $localStorage,
    $rootScope,
    $scope,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    $timeout,
    $location,
    TrackingService,
    ngProgressFactory,
    events
  ) {
    this.name = "positiontype";
    this.walkthroughState = WALKTHROUGH_STATES.POSITION;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$progress = ngProgressFactory.createInstance();
    this.waitForEventToLoad = true;
    this.$tracking = TrackingService;
    this.$events = events;
    this.jobble_types = this.$rootScope.jobble_types;

    this.API_FIELDS = "subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.jobbleType.name, subEvents.deduppedJobbles.jobbleType.id";

    this.PostAJobGlobalApiSyncListener = this.$rootScope.$on("PostAJobGlobalApiSync", ($event, params) => {
      let event = params.event;
      if (event) {
        this.$timeout(() => {
          this.waitForEventToLoad = false;
          $("#cloning-loading-event-data").modal("toggle");
          $(".modal-backdrop").remove();
        }, 2000);
      }
    });

    this.TriggerLoadingModalListener = this.$rootScope.$on("TriggerLoadingModal", ($event, params) => {
      this.$timeout(() => {
        $("#cloning-loading-event-data").modal();
      }, 350);
    });

    this.DoNotTriggerModalListener = this.$rootScope.$on("DoNotTriggerModal", ($event, params) => {
      this.event.back_end_loaded = true;
    });

    this.$scope.$on("$destroy", this.DoNotTriggerModalListener);
    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncListener);
    this.$scope.$on("$destroy", this.TriggerLoadingModalListener);
  }

  $onInit() {

    this.setLoader();

    if (this.$location.$$search.cid) {
      this.isClone = true;
    }

    if ((this.$location.$$search.cid || this.$location.$$search.eid) && !this.event.back_end_loaded) {
      this.waitForEventToLoad = true;
      this.showLoadingModal();
    } else {
      this.waitForEventToLoad = false;
    }

    if (this.event.position_type) {
      this.event.position_type = this.event.position_type + "";
    }

    if (this.event && this.event.id) {
      this.syncWithApi();
    }

    this.getJobbleTypes();
  }

  setWarehouseDefault() {
    if (!this.isClone) {
      if (!this.$rootScope.warehouse_jobble_type) {
        this.$rootScope.warehouse_jobble_type = this.findWarehouseJobType(this.jobble_types);
      }

      this.$timeout(() => {
        if (!this.event.position_type || !this.event.position_type.length) {
          if (this.$rootScope.warehouse_jobble_type && this.$rootScope.warehouse_jobble_type.id) {
            this.event.position_type = this.$rootScope.warehouse_jobble_type.id + "";
            this.updatePositionType();
          }
        }
      });
    }

    this.$timeout(() => {
      this.stripOutW2();
      this.unSetLoader();
    }, 1000);
  }

  stripOutW2() {
    if (this.$auth.isAdmin() === true) {
      console.log("we have an admin, leave w2 jobble type");
    } else {
      this.jobble_types.pop();
    }

    //TODO: strip out the undefined one
  }

  showLoadingModal() {
    this.$timeout(() => {
      $("#cloning-loading-event-data").modal();
    }, 350);
  }

  findWarehouseJobType(types) {
    let type = null;

    if (!types || !types.length) return type;

    types.forEach((t) => {
      const name = t.name.toLowerCase();
      if (name.indexOf("warehouse") !== -1) type = t;
    });

    return type;
  }

  syncWithApi() {
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
      const jobbleType = data.data.subEvents[0].deduppedJobbles[0].jobbleType;
      this.event.position_type = jobbleType.id + "";
    });
  }

  getJobbleTypes() {
    if (this.$rootScope.jobble_types) {
      this.$timeout(() => {
        this.jobble_types = this.$rootScope.jobble_types;
        if (!(this.event && this.event.id)) {
          this.setWarehouseDefault();
        } else {
          this.stripOutW2();
        }
      }, 1000);
    } else {
      this.$auth.getJobbleTypes().then((data) => {
        console.log("getting jobble types");
        console.dir(data.data);
        this.$timeout(() => {
          this.jobble_types = data.data;
          this.$rootScope.jobble_types = data.data;
          if (!(this.event && this.event.id)) {
            this.setWarehouseDefault();
          } else {
            this.stripOutW2();
          }
        });
      });
    }
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  setW2status(isW2) {
    if (isW2 !== true) {
      this.event.is_w2 = false;
    } else {
      this.event.is_w2 = true;
    }
  }

  updatePositionType() {
    console.log("updating position type");
    console.dir(this.event.position_type);

    if (this.event.position_type === "95") {
      this.setW2status(true);
    } else {
      this.setW2status(false);
    }

    this.event.forced_long_term = false;
    this.event.forced_one_time = false;

    if (this.$rootScope.warehouse_jobble_type && this.$rootScope.warehouse_jobble_type.id) {
      if (this.$rootScope.warehouse_jobble_type.id + "" === this.event.position_type + "") {
        console.log("Picked Warehouse Job Type");
        //this.event.forced_long_term = true;

        if (!this.event.is_long_term) {
          //this.event.is_long_term = false;
          this.event.shifts = [];

          console.log("UPDATE_WORKFLOW_EVENT_NAME");
          console.dir(UPDATE_WORKFLOW_EVENT_NAME);

          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
        }
      }
    }

    if (this.$rootScope.event_jobble_type && this.$rootScope.event_jobble_type.id) {
      if (this.$rootScope.event_jobble_type.id + "" === this.event.position_type + "") {
        console.log("Picked Event Staff Job Type");
        this.event.forced_one_time = true;

        if (this.event.is_long_term) {
          this.event.is_long_term = false;
          this.event.shifts = [];

          this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
        }
      }
    }

    if (this.event && this.event.id) {
      this.$timeout(() => {
        this.savingStep = true;
      });

      this.$timeout(() => {
        let jid;

        if (this.event.deduppedJobbleId) {
          jid = this.event.deduppedJobbleId;
        } else if (this.jobble_id) {
          jid = this.jobble_id;
        }
        if (jid) {
          this.$events.saveEventPositionType(this.jobble_id, this.event.position_type).then((data) => {
            this.updateEventW2Status(this.event);
            this.$timeout(() => {
              this.savingStep = false;
            });
            console.log("Saved position type:", data);
          });
        } else {
          console.warn("no jobble id, do not update jobble type");
        }
      }, 1000);
    }
  }

  updateEventW2Status(event) {
    this.$events.saveW2Status(this.event).then((data) => {
      console.log("Saved w2 status:", data);
    });
  }

  goNext() {
    this.$tracking.reportPostAJobSubmitStep("job type");
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }
}

PositiontypeController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "$location",
  "tracking",
  "ngProgressFactory",
  "events",
];

export default PositiontypeController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/positiontype/positiontype.controller.js